import { render } from "./ic-signout.vue?vue&type=template&id=28287398"
import script from "./ic-signout.vue?vue&type=script&lang=js"
export * from "./ic-signout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__